var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8131 4.46847L9.53352 0.186932C9.4142 0.0676137 9.25114 0 9.0821 0H0.636364C0.284375 0 0 0.284375 0 0.636364V17.1818C0 17.5338 0.284375 17.8182 0.636364 17.8182H13.3636C13.7156 17.8182 14 17.5338 14 17.1818V4.9179C14 4.74886 13.9324 4.58778 13.8131 4.46847ZM4.77273 6.72159C5.21222 6.72159 5.56818 7.07756 5.56818 7.51705C5.56818 7.95653 5.21222 8.3125 4.77273 8.3125C4.33324 8.3125 3.97727 7.95653 3.97727 7.51705C3.97727 7.07756 4.33324 6.72159 4.77273 6.72159ZM10.6591 12.5682H3.34091C3.20767 12.5682 3.13409 12.4151 3.21563 12.3116L5.20028 9.7821C5.21517 9.76309 5.23418 9.74771 5.25589 9.73713C5.27759 9.72656 5.30142 9.72106 5.32557 9.72106C5.34971 9.72106 5.37354 9.72656 5.39525 9.73713C5.41696 9.74771 5.43597 9.76309 5.45085 9.7821L6.26818 10.8241L7.81534 8.85142C7.83022 8.83241 7.84924 8.81703 7.87094 8.80645C7.89265 8.79588 7.91648 8.79038 7.94062 8.79038C7.96477 8.79038 7.9886 8.79588 8.01031 8.80645C8.03201 8.81703 8.05103 8.83241 8.06591 8.85142L10.7804 12.3116C10.8659 12.4151 10.7903 12.5682 10.6591 12.5682ZM8.78977 5.21023V1.46761L12.5324 5.21023H8.78977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageThumb);
export default __webpack_public_path__ + "static/media/imageThumb.248168a76810576650293cab11832c72.svg";
export { ForwardRef as ReactComponent };